/*
 * Copyright (c) Domotz Ltd. All rights reserved.
 */

import React from 'react';
import {Link} from 'react-router-dom';
import intl from 'react-intl-universal';

import OutageSeverityIndicator from "../isp/OutageSeverityIndicator";

class OutageRelatedList extends React.Component {

    outage() {
        return this.props.outage;
    }

    limit() {
        return this.props.limit || 5;
    }

        impactThreshold() {
            return this.props.impactThreshold || 35;
        }


    // --------------------------------------------------------------------------------

    render() {
        let outage = this.outage();
        const limit = this.limit();

        if (outage.relatedReports === undefined)
            return '';

        let filter = outage.relatedReports.slice(0, limit);

        if (this.props.compact) {
            if (filter.length === 0) {
                return '';
            }
            return this.renderCompact(filter);
        } else {
            return this.renderLong(outage, filter);
        }
    }

    classForImpact(relativeImpact) {
        if (relativeImpact < 40) {
            return "text-secondary";
        } else if (relativeImpact < 80) {
            return "text-body";
        } else  {
            return "text-danger";
        }
    }

    // --------------------------------------------------------------------------------
    // Render COMPACT list
    // --------------------------------------------------------------------------------

    renderCompact(listOfRelateds) {
        const faIcon = 'fa-calendar-times';
        return (
            <div className="d-flex">
                <div className="flex-column p-0 m-0">
                    <small className={"fas fa-fw " + faIcon + " text-secondary align-middle mr-2"}/>
                </div>
                <div className="flex-column p-0 m-0">
                    <span className="align-middle small text-secondary">
                        {listOfRelateds.map((drill, index) => this.renderCompactRelated(drill, (index === listOfRelateds.length - 1)))}
                    </span>
                </div>
            </div>
        );
    }

    renderCompactRelated(related, isLast) {
        let separator = (isLast ? '' : ', ');
        if (related.impactPerc > this.impactThreshold()) {
            return (<span>
                <strong className="text-body">{related.type}</strong>{separator}</span>
            );
        } else {
            return (<span>{related.type}{separator}</span>);
        }
    }

    // --------------------------------------------------------------------------------
    // Render LONG list
    // --------------------------------------------------------------------------------

    renderLong(outage, listOfRelateds) {
        if (!outage || !listOfRelateds)
            return '';

        const maxLength = 5;
        const listId = 'place-list-' + new Date().getTime();

        if (listOfRelateds.length > maxLength) {
            return (
                <ul style={{listStyle: 'none'}} className="p-0" >
                    {listOfRelateds.slice(0, maxLength).map(drill => this.renderLongRelated(outage, drill))}
                    <div className="collapse" id={listId}>
                        {listOfRelateds.slice(maxLength, this.limit()).map(drill => this.renderLongRelated(outage, drill))}
                    </div>
                    <a className="link link-collapse small font-size-1 collapsed mt-2"
                       data-toggle="collapse"
                       href={'#' + listId} role="button"
                       aria-expanded="false"
                       aria-controls={listId}>
                        <span className="link-collapse-default">{intl.get('generic_view_more')}</span>
                        <span className="link-collapse-active">{intl.get('generic_view_less')}</span>
                        <span className="link-icon ml-1">
                        <span className="link-icon-inner">+</span>
                    </span>
                    </a>
                </ul>
            );
        } else if (listOfRelateds.length > 0) {
            return (
                <ul style={{listStyle: 'none'}} className="p-0">
                    {listOfRelateds.map(drill => this.renderLongRelated(outage, drill))}
                </ul>
            );
        } else {
            return (
                <ul style={{listStyle: 'none'}} className="p-0">
                    <li className="small align-middle">
                        <span className={this.classForImpact(0)}>No related report</span>
                    </li>
                </ul>
            );
        }
    }

    renderLongRelated(outage, drill) {
        let relativeImpact = (20.0 * drill.severityNum);

        let within24Hours = (outage.endTime - drill.startTime) <= 60000 * 60 * 24;

        const options = within24Hours ? {hour: 'numeric', minute: 'numeric'} : {weekday: 'short',  day: 'numeric', hour: 'numeric', minute: 'numeric'};
        let startDate = new Date(drill.startTime);
        let startTime = within24Hours ? startDate.toLocaleTimeString("en-US", options) : startDate.toLocaleDateString("en-US", options);

        let title = drill.type;
        if (drill.correlatedLocation) title = drill.correlatedLocation;

        return (
            <li className="small align-middle">
                <span className="mr-2">{this.renderScore(relativeImpact)}</span>
                <span className={this.classForImpact(relativeImpact)}>{drill.severity} at {startTime} </span>
                <Link className="link-underline" to={'/outage/'+drill.reportId}>({title})</Link>
            </li>
        );
    }

    renderScore(relativeImpact) {
        return <OutageSeverityIndicator score={relativeImpact} />
    }

}

export default OutageRelatedList;